'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.growlFromNativeCalls = growlFromNativeCalls;
exports.growlToNativeCalls = growlToNativeCalls;
exports.growl = growl;
exports.warn = warn;
exports.getNativeValues = getNativeValues;

var _reactNotifications = require('react-notifications');

require('react-notifications/lib/notifications.css');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var verboseActive = /verbose/.test(window.location.toString());

exports.default = verboseActive ? function (_NotificationContaine) {
  _inherits(VerboseUI, _NotificationContaine);

  function VerboseUI() {
    _classCallCheck(this, VerboseUI);

    return _possibleConstructorReturn(this, (VerboseUI.__proto__ || Object.getPrototypeOf(VerboseUI)).apply(this, arguments));
  }

  return VerboseUI;
}(_reactNotifications.NotificationContainer) : function () {
  return null;
};


setTimeout(function () {
  _reactNotifications.NotificationManager.warning('Verbose is active!');
}, 1000);

function growlFromNativeCalls(payload) {
  if (!verboseActive) return;
  var nativeValues = getNativeValues(payload);
  var message = 'From Method: ' + payload.methodName + '\n     ' + (nativeValues.length > 0 ? 'Values: ' + nativeValues.join('\n') : '');
  console.info(message);
  console.log('payload:', payload);
  _reactNotifications.NotificationManager.info(message);
}

function growlToNativeCalls(payload) {
  if (!verboseActive) return;
  var nativeValues = getNativeValues(payload);
  var message = 'To Method: ' + payload.methodName + '\n      ' + (nativeValues.length > 0 ? 'Values: ' + nativeValues.join('\n') : '');
  console.info(message);
  console.log('payload:', payload);
  _reactNotifications.NotificationManager.info(message);
}

function growl(message) {
  if (!verboseActive) return;
  console.info(message);
  _reactNotifications.NotificationManager.warning(message);
}

function warn(message) {
  if (!verboseActive) return;
  console.warn(message);
  _reactNotifications.NotificationManager.error(message);
}

function getNativeValues(payload) {
  return Object.keys(payload).filter(function (key) {
    return key !== 'methodName';
  }).sort().map(function (key) {
    return key + ': ' + JSON.stringify(payload[key], null, 2);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/verbose-ui/lib/index.js
// module id = 209
// module chunks = 0